module.exports = __webpack_public_path__ + "static/about-huge-2-223566c2660f075c3e36cafe3c4875f4.jpg";